import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
const routes: Routes = [
  {
    path: "",
    loadChildren: ()=> import('./loan-gtm/loan-gtm-routing.module').then(m=>m.LoanGtmRoutingModule)
  },
  { path: 'loan-gtm', loadChildren: () => import('./loan-gtm/loan-gtm.module').then(m => m.LoanGtmModule) },
  {
    path: '**',
    loadChildren: () =>
    import('./../../../apna-lib/src/lib/components/page404/page404.module').then((m) => m.Page404Module),
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
